/**
 * Online Order Menu Page
 *
 * The menu is the restaurant's public storefront menu
 * (GET /api/storefront/menu/{slug}, rendered by StorefrontPage with the real
 * cart). /menu sends the guest to the storefront of the restaurant they are
 * ordering from (the slug the cart remembers).
 */

import React from 'react';
import { Navigate, Link } from 'react-router-dom';
import { Store } from 'lucide-react';
import { Button } from '@/components/ui/button';
import { useCart } from '../context/CartContext';

export default function MenuPage() {
  const { restaurantSlug } = useCart();

  if (restaurantSlug) {
    return <Navigate to={`../storefront/${encodeURIComponent(restaurantSlug)}`} relative="path" replace />;
  }

  return (
    <div className="min-h-screen bg-slate-50 flex items-center justify-center px-4">
      <div className="max-w-sm text-center space-y-4">
        <Store className="w-12 h-12 mx-auto text-slate-400" />
        <h1 className="text-xl font-bold">Which restaurant?</h1>
        <p className="text-slate-500">
          Open the ordering link your restaurant shared (it ends in the
          restaurant's name) to see its menu.
        </p>
        <Link to="..">
          <Button variant="outline">Back</Button>
        </Link>
      </div>
    </div>
  );
}
